import { useTranslation } from 'react-i18next'
import { WaveProgress } from '@/src/renderer/components/ui/WaveProgress'
import { Button } from '@/src/renderer/components/ui/Button'
import { X } from 'lucide-react'
import './ClarifyHeader.scss'

export interface ClarifyHeaderProps {
  done: number
  total: number
  progress: number // 0..1
  onFinish: () => void
  /**
   * Der Ausgang (Abnahme 21.09.2026, F-KN1). Er lag vorher nur auf Escape —
   * und das kam nicht an, solange der Fokus in einem Feld stand. Ein Ablauf,
   * den man nur über einen Tabwechsel verlässt, hat keinen Ausgang.
   */
  onExit: () => void
}

/**
 * Kopfzeile im Clarify-Mode:
 *   [×]  [Aufräumen]   [X von Y einsortiert]   [WaveProgress]   [Einsortieren K]
 */
export function ClarifyHeader({ done, total, progress, onFinish, onExit }: ClarifyHeaderProps) {
  const { t } = useTranslation()

  return (
    <div className="clarify-header">
      <button
        type="button"
        className="clarify-header__exit"
        onClick={onExit}
        aria-label={t('quickNotes.clarify.exit')}
      >
        <X size={16} aria-hidden="true" />
      </button>

      <span className="clarify-header__label">
        {t('quickNotes.clarify.subtitle')}
      </span>

      <span className="clarify-header__count">
        {t('quickNotes.clarify.progress', { done, total })}
      </span>

      <WaveProgress value={progress} />

      <Button
        variant="primary"
        shortcut={{ kind: 'character', text: 'K' }}
        onClick={onFinish}
        disabled={done === 0}
      >
        {done === 0
          ? t('quickNotes.clarify.done')
          : t('quickNotes.clarify.doneCount', { count: done })}
      </Button>
    </div>
  )
}
